export const DIRECTIONS = {
  previous: 'previous',
  next: 'next',
};